<script lang="ts" setup>
// -------------------------------
// 🔹 Imports externes / types
// -------------------------------
import type { IBaseInputProps } from '@/types/base_Input.types';

// -------------------------------
// 🔹 Props & model
// -------------------------------
defineProps<IBaseInputProps>();
const model = defineModel<any>();

// -------------------------------
// 🔹 Émission d’événements
// -------------------------------
const emit = defineEmits<{
  (e: 'HandleChecked', payload: Event): void;
}>();

// -------------------------------
// 🔹 Gestion du changement de valeur
// -------------------------------

/**
 * Émet un événement `HandleChecked` lorsque la valeur du champ change.
 * @param {Event} event Événement déclenché par l'input
 */
const HandleChangeValue = (event: Event) => {
  emit('HandleChecked', event);
};
</script>

<template>
  <input
    :value="value"
    :type="type"
    :name="name"
    v-model="model"
    :id="id"
    @change="HandleChangeValue"
    class="isChecked custom-checkbox my-0"
  />
</template>
